import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ax_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); localStorage.setItem("ax_user", JSON.stringify(r.data)); })
      .catch((e) => {
        if (e?.response?.status === 401) localStorage.removeItem("ax_token");
        else setUser(JSON.parse(localStorage.getItem("ax_user") || "null"));
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, deviceToken, u) => {
    localStorage.setItem("ax_token", token);
    if (deviceToken) localStorage.setItem("ax_device", deviceToken);
    localStorage.setItem("ax_user", JSON.stringify(u));
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("ax_token");
    localStorage.removeItem("ax_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
